import { combineReducers } from '@reduxjs/toolkit'

import { IRedeemState } from 'types'
import { redeemReducer } from 'features/redeem'
import {
  walletReducer,
  modalReducer,
  campaignPublicReducer,
  buyerReducer,
  alertsReducer,
  currencyReducer,
  rewardPublicReducer,
} from 'primsell-shared-layer/features'
import {
  IWalletState,
  IMetamaskState,
  IModalState,
  ICampaignPublicState,
  IBuyerState,
  IAlertState,
  ICurrencyState,
  IRewardPublicState,
} from 'primsell-shared-layer/types'

const rootReducer = combineReducers({
  alerts: alertsReducer,
  modal: modalReducer,
  redeem: redeemReducer,
  wallet: walletReducer,
  campaignPublic: campaignPublicReducer,
  buyer: buyerReducer,
  currency: currencyReducer,
  rewardPublic: rewardPublicReducer,
})

export interface RootState {
  alerts: IAlertState
  metamask: IMetamaskState
  modal: IModalState
  redeem: IRedeemState
  wallet: IWalletState
  campaignPublic: ICampaignPublicState
  buyer: IBuyerState
  currency: ICurrencyState
  rewardPublic: IRewardPublicState
}

declare global {
  type AppState = RootState
  type AppSelector<T = unknown> = (state: AppState) => T
}

// With this, `useSelector(state => ...)` automatically infers `state` param as `AppState`
declare module 'react-redux' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultRootState extends AppState {}
}

export { rootReducer }
